import { createFileRoute } from '@tanstack/react-router';
import { uuidOrUndefined } from '../../foundry/href.js';
import { ImportPage } from '../../foundry/ImportPage.js';

export interface FoundrySearch {
  /** The character sheet a refresh started from (its pill, stage s2). */
  sheet?: string | undefined;
}

/** `/foundry`: the import page; `validateSearch` keeps `sheet` (a uuid) and drops anything else. */
export const Route = createFileRoute('/foundry/')({
  validateSearch: (search: Record<string, unknown>): FoundrySearch => ({
    sheet: uuidOrUndefined(search.sheet),
  }),
  component: FoundryRoute,
});

function FoundryRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const { sheet } = Route.useSearch();
  return <ImportPage me={me} sheet={sheet} />;
}
